import React from "react";
import { Radio } from "antd";
import { CustomFormItemStatus } from "../Form";

const { Group: RadioGroup } = Radio;

class RadioGroupComponent extends React.Component {
  render() {
    const {
      getFieldDecorator,
      decodator,
      value,
      required,
      disabled,
      options,
      onChange,
    } = this.props;

    // console.log("daySelected", daySelected);

    return (
      <div style={{ marginBottom: 20 }}>
        <CustomFormItemStatus>
          {getFieldDecorator(decodator, {
            initialValue: value || undefined,
            rules: [
              {
                required,
                message: ".",
              },
            ],
          })(
            <RadioGroup
              disabled={disabled}
              style={{
                display: "flex",
              }}
              options={options}
              onChange={onChange}
            />
          )}
        </CustomFormItemStatus>
      </div>
    );
  }
}

export default RadioGroupComponent;
